module.exports = __webpack_public_path__ + "static/media/mediaDore.ab92a41b.svg";